'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createServiceForTest = createServiceForTest;

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _urlUtils = require('../urlUtils');

var noOpDecorator = function noOpDecorator(target, key, descriptor) {
    return descriptor;
};
var noOpDecoratorFactory = function noOpDecoratorFactory() {
    return noOpDecorator;
};

/**
 * For test service without domain
 */
function createServiceForTest(superAgent, pathPrefix, serviceFactory) {
    _auroraJavascriptUtils.assert.object(superAgent);
    _auroraJavascriptUtils.assert.string(pathPrefix);
    _auroraJavascriptUtils.assert.func(serviceFactory);

    return serviceFactory({
        superAgent: superAgent,
        urlBuilder: (0, _urlUtils.createUrlBuilder)(pathPrefix)
    }, {
        Command: noOpDecoratorFactory,
        Query: noOpDecoratorFactory,
        Cacheable: noOpDecoratorFactory,
        CacheEvict: noOpDecoratorFactory,
        EvictCollectionCache: noOpDecoratorFactory,
        Href: noOpDecoratorFactory
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/createServiceForTest.js
// module id = 1424
// module chunks = 118